import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../middleware/dataSlice';

interface GetCommissionValueRequest {
    value: number;
    type: string;
    currencyId: string;
    companyId: number;
    customerId: number;
}

interface CommissionData {
    processType: number;
    value: number;
    feeTypeIndicator: string;
    fee: number;
    valueFee: number;
    total: number;
}

interface GetCommissionValueResponse {
    data: CommissionData;
    success: boolean;
    message: string | null;
    statusCode: number;
}

interface SendMoneyItem {
    currencyId: string;
    value: number;
    receiverWalletNo: string;
    description: string;
    status: string | null;
    message: string | null;
    success: boolean | null;
    statusClass: string | null;
    statusDisplay: string | null;
}

interface SendMoneyRequest {
    data: SendMoneyItem[];
    companyId: number;
    customerId: number;
}

interface SendMoneyResponse {
    success: boolean;
    message: string | null;
    statusCode: number;
}

interface AddIbanRequest {
    currencyId: number;
    receiverIBAN: string;
    receiverFullName: string;
    customerId: number;
    companyId: number;
}

interface AddIbanResponse {
    success: boolean;
    message: string;
    statusCode: number;
}

interface RemoveIbanResponse {
    success: boolean;
    message: string;
    statusCode: number;
}

// Withdrawal modelleri
interface WithdrawalData {
    currencyId: number;
    value: number;
    description: string;
    valueFee: number;
    ibanId: number;
}

interface WithdrawalRequest {
    data: WithdrawalData;
    companyId: number;
    customerId: number;
}

interface WithdrawalResponse {
    success: boolean;
    message: string;
    statusCode: number;
}
interface CommisionRequest {
    value: string;
    type: string;
    currencyId: string;
    companyId: number;
    customerId: number;
}
interface ListCommisionRequest {
    data: CommisionRequest[];
    companyId: number;
    customerId: number;
}
interface CommissionResponse {
    data: {
        totalCommissionTl: number;
        totalCommissionUsd: number;
        totalCommissionEur: number;
    };
    success: boolean;
    message: string | null;
    statusCode: number;
}

// SendMoneyList request model
interface SendMoneyListItem {
    description: string;
    receiverWalletNo: string;
    currencyId: string;
    value: number;
}

interface SendMoneyListRequest {
    data: SendMoneyListItem[];
    companyId: number;
    customerId: number;
}

// SendMoneyList response model
interface SendMoneyListResponse {
    success: boolean;
    message: string;
    statusCode: number;
}

export const transferAPI = createApi({
    reducerPath: 'transferAPI',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['transferAPI'],
    endpoints: (builder) => ({
        getListCommissionValue: builder.mutation<CommissionResponse, ListCommisionRequest>({
            query: (payload) => ({
                url: '/Commission/getListCommissionValue',
                method: 'POST',
                body: payload,
            }),
        }),
        getCommissionValue: builder.mutation<GetCommissionValueResponse, GetCommissionValueRequest>({
            query: (payload) => ({
                url: '/Commission/getCommissionValue',
                method: 'POST',
                body: payload,
            }),
        }),
        sendMoney: builder.mutation<SendMoneyResponse, SendMoneyRequest>({
            query: (payload) => ({
                url: '/Process/SendMoney',
                method: 'POST',
                body: payload,
            }),
        }),
        getLastFiveTransactions: builder.query<any, { customerId: number, processType: number }>({
            query: ({ customerId, processType }) => ({
                url: `/Process/GetLastFiveTransactions?customerId=${customerId}&processType=${processType}`,
                method: 'GET',
            }),
        }),
        addIban: builder.mutation<AddIbanResponse, AddIbanRequest>({
            query: (payload) => ({
                url: '/Company/addIban',
                method: 'POST',
                body: payload,
            }),
        }),
        corporateMultipleSendTypes: builder.query<any, { companyId: number }>({
            query: ({ companyId }) => ({
                url: `/Process/CorporateMultipleSendTypes?companyId=${companyId}`,
                method: 'GET',
            }),
        }),
        getIbans: builder.query<any, { customerId: number }>({
            query: ({ customerId }) => ({
                url: `/Company/GetIbans?customerId=${customerId}`,
                method: 'GET',
            }),
        }),
        removeIban: builder.mutation<RemoveIbanResponse, { id: number }>({
            query: ({ id }) => ({
                url: `/Company/RemoveIban?ibanId=${id}`,
                method: 'GET',
            }),
        }),
        withdrawal: builder.mutation<WithdrawalResponse, WithdrawalRequest>({
            query: (body) => ({
                url: `Process/Withdrawal`,
                method: 'POST',
                body,
            }),
        }),
        sendMoneyList: builder.mutation<SendMoneyListResponse, SendMoneyListRequest>({
            query: (payload) => ({
                url: '/Process/SendMoneyList',
                method: 'POST',
                body: payload,
            }),
        }),
        getBalanceForSendMoney: builder.query<any, { companyId: number }>({
            query: ({ companyId }) => ({
                url: `/Company/getBalanceForSendMoney?companyId=${companyId}`,
                method: 'GET',
            }),
        }),
        sendMoneyPhoneNumberList: builder.mutation<any, any>({
            query: (payload) => ({
                url: '/process/SendMoneyPhoneNumberList',
                method: 'POST',
                body: payload
            })
        }),
        sendMealAllowanceListAsync: builder.mutation<any, any>({
            query: (payload) => ({
                url: '/process/SendMealAllowanceListAsync',
                method: 'POST',
                body: payload
            })
        }),
        sendCashbackList: builder.mutation<any, any>({
            query: (payload) => ({
                url: '/process/SendCashbackList',
                method: 'POST',
                body: payload
            })
        })
    }),
});

export const { useSendCashbackListMutation, useSendMealAllowanceListAsyncMutation, useSendMoneyPhoneNumberListMutation, useGetListCommissionValueMutation, useGetCommissionValueMutation, useSendMoneyMutation, useGetLastFiveTransactionsQuery, useAddIbanMutation, useCorporateMultipleSendTypesQuery, useGetIbansQuery, useRemoveIbanMutation, useWithdrawalMutation, useSendMoneyListMutation, useGetBalanceForSendMoneyQuery } = transferAPI;
